// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sendSms } from 'client/actions/sms';
import Translate from 'client/components/translate';
import InputPhone from 'client/components/form/inputPhone';
import { SMS_FAILED, SMS_INVALID_PHONE_NUMBER, SMS_SENT } from 'client/constants/amplitudeTracker';
import { Tracking } from 'web-core/src/tracking';
import type { TranslateType } from 'types/translateType.flow';

const mapStateToProps: Object = (state, { smsKey }) => ({
  isSmsPending: _.filter(state.sms.pending, { key: smsKey }).length > 0,
});

type Props = {
  isSmsPending: boolean,
  sendSms: Function,
  shouldFocus: boolean,
  smsCtaText: string,
  smsFailed: string,
  smsKey: string,
  smsUrl: string,
  source: string,
  wrapInForm: boolean,
};

type States = {
  phoneError: TranslateType | null,
  phoneNumber: string,
};

class SmsPhoneInput extends Component<Props, States> {
  static defaultProps = {
    isSmsPending: true,
    shouldFocus: false,
    source: '',
    wrapInForm: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      phoneError: null,
      phoneNumber: '',
    };
  }

  onPhoneChange = (phoneNumber) => {
    this.setState({
      phoneNumber,
      phoneError: phoneNumber.length === 14 ? null : this.state.phoneError,
    });
  };

  onTextSubmit = (e) => {
    e.preventDefault();
    const { isSmsPending, smsFailed, smsKey, smsUrl, source } = this.props;
    const phoneDigits = this.state.phoneNumber.replace(/[^\d]/g, '');
    if (phoneDigits.length !== 10) {
      this.setState({
        phoneError: {
          path: 'common.error.invalidPhone',
        },
      });
      Tracking.track(SMS_INVALID_PHONE_NUMBER, { Source: source });
    } else if (!isSmsPending) {
      this.setState({ phoneError: null });

      this.props
        .sendSms({
          key: smsKey,
          url: smsUrl,
          payload: {
            phone: phoneDigits,
            source,
          },
        })
        .then(() => {
          Tracking.track(SMS_SENT, { Source: source });
        })
        .catch(() => {
          Tracking.track(SMS_FAILED, { Source: source });
          this.setState({
            phoneError: { path: '', fallback: smsFailed },
          });
        });
    }
  };

  render() {
    const { phoneNumber, phoneError } = this.state;
    const { isSmsPending, shouldFocus, smsCtaText, wrapInForm } = this.props;

    const smsInput = (
      <InputPhone
        id="phone-number"
        label={{ path: 'common.label.cellPhone' }}
        value={phoneNumber}
        error={phoneError}
        changeHandler={this.onPhoneChange}
        shouldFocus={shouldFocus}>
        <button
          style={{ padding: '0 1rem' }}
          className={isSmsPending ? 'disabled' : ''}
          onClick={this.onTextSubmit}>
          {smsCtaText ? (
            <Translate fallback={smsCtaText} />
          ) : (
            <Translate path="taxes.dashboard.nonTaxUser.hero.textLink" />
          )}
        </button>
      </InputPhone>
    );
    return wrapInForm ? <form onSubmit={this.onTextSubmit}>{smsInput}</form> : smsInput;
  }
}

export default connect(mapStateToProps, { sendSms })(SmsPhoneInput);
